export default {
    "dc": "Đang chạy",
    "dh": "Đã hoàn",
}
